import React from 'react';
import { Link } from 'react-router-dom';
import { HiBellAlert } from "react-icons/hi2";
import snehasangamamReport from '../assets/announcement materials/20.jpg';


const NewAnnouncements = () => {
  return (
    <div className="announcement-pop fixed bottom-20 left-4 z-40 w-60 transition-transform duration-300 hover:-translate-y-1 sm:bottom-24 sm:left-8 sm:w-64">
      <Link
        to="/announcement"
        className="group block overflow-hidden rounded-2xl border border-white/80 bg-white/90 shadow-[0_12px_32px_rgba(20,91,92,0.2)] backdrop-blur-md transition-shadow hover:shadow-[0_16px_36px_rgba(20,91,92,0.28)] focus:outline-none focus:ring-2 focus:ring-tb"
        aria-label="View new announcements"
      >
        <div className="relative">
          <img
            src={snehasangamamReport}
            className="h-36 w-full object-cover object-center transition-transform duration-500 group-hover:scale-105 sm:h-40"
            alt="അയ്യപ്പപ്പണിക്കർ സ്നേഹസംഗമം 2026-ൽ കെ. സച്ചിദാനന്ദനെ ആദരിക്കുന്ന ചടങ്ങ്"
          />
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-white/90 px-2 py-1 text-xs font-bold text-tb shadow-sm">
            <HiBellAlert />
            New
          </span>
        </div>
        <span className="flex items-center justify-between gap-2 bg-tb px-3 py-2.5 text-sm font-semibold text-white">
          <span>അയ്യപ്പപ്പണിക്കർ സ്നേഹസംഗമം 2026</span>
          <span aria-hidden="true" className="text-lg transition-transform group-hover:translate-x-1">→</span>
        </span>
      </Link>
    </div>
  )
}

export default NewAnnouncements